import BentoBox, {
  TBentoBox,
} from "@template/blocks/BentoBoxGrid/component/BentoBox";
import * as S from "./styles.ts";

interface IBentoBoxGrid {
  items: TBentoBox[];
  gap?: number;
  borderRadius?: number;
}

const BentoBoxGrid = ({ items, gap = 4, borderRadius = 4 }: IBentoBoxGrid) => {
  return (
    <S.Wrapper>
      <S.Container
        style={{
          gap,
        }}
      >
        {items.map((item, i) => (
          <BentoBox
            key={i}
            box={item}
            borderRadius={borderRadius}
            gap={gap}
          />
        ))}
      </S.Container>
    </S.Wrapper>
  );
};

export default BentoBoxGrid;
